




































































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';

/**
 * Types
 */
import { SettingsResponseModel } from '@/api/settings';
import { IsAuthorizedType } from './permissions/store';

export interface SubItemCategory {
	icon: string;
	link?: string;
	text: string;
	enabled?: (settings: SettingsResponseModel, isAuthorized: IsAuthorizedType) => boolean;
	items?: SubItemCategory[];
}

export interface ItemCategories {
	text: string;
	items: SubItemCategory[];
}

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');
const agentPermissionsModule = namespace('permissions');

/**
 * Composant représentant le menu global à gauche de la fenêtre.
 */
@Component
export default class AppNavigationDrawer extends Vue {
	/** Propriétés */
	@Prop()
	title!: string;

	@Prop()
	image!: string;

	@Prop()
	itemCategories!: ItemCategories;

	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** VueX - Agent Permissions */
	@agentPermissionsModule.Getter
	isAuthorized!: IsAuthorizedType;

	/** Attributs */
	drawerModel: boolean | null = null;

	/** v-model */
	@Model('drawer-changed')
	drawer!: boolean;

	/** Méthodes */
	isItemAndChildrenEnabled(item: any): boolean {
		return (item.enabled == null || (this.settings != null && item.enabled(this.settings, this.isAuthorized)))
			&& (item.items == null || (item.items != null && item.items.some(this.isItemAndChildrenEnabled)));
	}

	/** Watchers */
	@Watch('drawer')
	drawerWatcher(val: boolean) {
		this.drawerModel = val;
	}
	@Watch('drawerModel')
	drawerModelWatcher(val: boolean) {
		this.$emit('drawer-changed', val);
	}

	// findRoutePropertyFromArray(path: string, routesPropArray: any[]): any {
	// 	const itemRoot = routesPropArray.find((x: any) => x.path.includes(path));
	// 	return itemRoot != null ? itemRoot : this.findRoutePropertyFromArray(routesPropArray.children, );
	// }

	// findRouteProperty(path: string) {
	// 	const router = this.$router as any;
	// 	return this.findRoutePropertyFromArray(path, router.options.routes);
	// }
}
